export const premiumPayoutFilterState = () => ({
  month: null,
  year: null,
  searchKey: null,
})